import {useMemo,useState} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import Popover from 'react-bootstrap/Popover'
import Spinner from 'react-bootstrap/Spinner'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import {
	useRefreshPayments,
	usePayments
} from '../hooks'
import LocaleCurrency from '../../LocaleCurrency/LocaleCurrency'
import LocaleDate from '../../LocaleDate/LocaleDate'
import UserThumbnail from '../../UserThumbnail/UserThumbnail'
import DatePicker from 'react-datepicker'
import {dateToYMD} from '../../../util/util'
import useCurrentUser from '../../../hooks/useCurrentUser'
import DiscussResourceButton from '../../DiscussResourceButton/DiscussResourceButton'
import {useHistory} from 'react-router-dom'
import {editPaymentComment} from './paymentsSlice'

//comment
const Payment = ({payment})=>{
	const user = useCurrentUser()
	const isClient = user.account_type === 'client'
	const dispatch = useDispatch()
	const handleUpdateComment = (e)=>{
		dispatch(editPaymentComment({
			payment_id:payment.payment_id,
			comment:e.target.value
		}))
	}
	return (
		<div style={{
			borderBottom:'1px solid #ccc',
			padding:'4px 8px',
			display:'flex',
			alignItems:'center'
		}}>
			<span style={{width:'100px',flex:'0 0 auto'}}><LocaleDate date={payment.date}/></span>
			{user.account_type !== 'client'&&
				<div style={{width:'180px',flex:'0 0 auto'}}>
					<span className="mx-2 text-muted">|</span>
					<UserThumbnail src={payment.client_profile_pic}/>
					<span className="mr-2">{payment.client_user_name}</span>
				</div>
			}
			{(isClient&&Boolean(payment.comment))&&
				<div className="mx-1" style={{fontSize:'14px'}}>
					{payment.comment}
				</div>
			}
			{!isClient&&
				<Form.Control
					onBlur={handleUpdateComment}
					defaultValue={payment.comment}
					style={{height:'32px',minHeight:'32px'}}
					placeholder="comments"
					className="mx-1"
					as="textarea"
					size="sm"
				/>
			}
			<span style={{width:'160px',flex:'0 0 auto'}} className="ml-auto text-success">
				<LocaleCurrency ISO={payment.currency_ISO} amount={payment.amount}/>
			</span>
			<span className="mx-2 text-muted">|</span>
			<span style={{width:'40px',flex:'0 0 auto'}}>
				{payment.payment_id}
			</span>
			<OverlayTrigger overlay={
				<Tooltip>Discuss this payment in the chat</Tooltip>
			}>
				<span>
					<DiscussResourceButton
						user_id_number={payment.client_id}
						pendingText=""
						className="btn btn-sm btn-link text-info"
						name={"Payment"}
						id={payment.payment_id}
						type="payment"
					>
						<i className="fa fa-comments"/>
					</DiscussResourceButton>
				</span>
			</OverlayTrigger>
		</div>
	)
}

const Total = ({amount,ISO})=>{
	return (
		<div style={{
			borderBottom:'2px solid #1f1f1f',
			padding:'8px',
			display:'flex',
			alignItems:'center'
		}}>
			<strong style={{width:'100px',flex:'0 0 auto'}}>Total</strong>
			
			<span style={{width:'160px',flex:'0 0 auto'}} className="ml-auto text-success text-right">
				<LocaleCurrency ISO={ISO} amount={amount}/>
			</span>
		</div>
	)
}

const Payments = ()=>{
	const history = useHistory()
	const urlParams = new URLSearchParams(window.location.search)
	const filterId = urlParams.get('payment_id') || ''
	const user = useCurrentUser()
	const {status,payments} = usePayments()
	const refresh = useRefreshPayments()
	const isOwner = (
		parseInt(user.gym_id) === 0
		? user.account_type === 'trainer'
		: user.account_type === 'gym'
	)
	const [clientQuery,setClientQuery] = useState('')
	const defaultDate = (
		(Boolean(urlParams.get('date'))&&new Date(urlParams.get('date'))) || ''
	)
	const [startDate,setStartDate] = useState(defaultDate)
	const [endDate,setEndDate] = useState(defaultDate)
	const [filterByDateRange,setFilterByDateRange] = useState(false)
	const [amountQuery,setAmountQuery] = useState('')
	const [IDQuery,setIDQuery] = useState(filterId)
	const stripePayoutUrl = useSelector(state=>(
		isOwner
		? state.users.current_user.stripe_account.payout_dashboard_url
		: ''
	))
	const matchesFilter = p => {
		const matchesClient = (
			!Boolean(clientQuery) ||
			p.client_user_name?.toLowerCase().includes(clientQuery.toLowerCase())
		)

		const matchesAmount = (
			!Boolean(amountQuery) ||
			p.amount?.toLowerCase().includes(amountQuery.toLowerCase())
		)

		const matchesID = (
			!Boolean(IDQuery) ||
			String(p.payment_id)?.toLowerCase().includes(IDQuery.toLowerCase())
		)

		const matchesDate = (
			!Boolean(startDate) ||
			(
				Boolean(startDate) &&
				Boolean(endDate) &&
				dateToYMD(startDate) <= p.date
				&&
				dateToYMD(endDate) >= p.date
			)
		)

		return (
			matchesClient &&
			matchesAmount &&
			matchesID &&
			matchesDate
		)
	}

	const [sortMultiplier,setSortMultiplier] = useState(1)

	const filteredPayments = useMemo(
		()=>payments.filter(matchesFilter).sort((a,b)=> a.date < b.date ? 1*sortMultiplier : -1*sortMultiplier),
		[payments,clientQuery,startDate,amountQuery,IDQuery,sortMultiplier,endDate]
	)

	const total = filteredPayments.reduce(
		(carry,payment)=> carry + parseFloat(payment.amount),
		0
	).toFixed(2)

	const filters = (
		<div 
			style={{flex:'0 0 auto'}} 
			className="d-flex flex-row align-items-end align-items-lg-start flex-lg-column justify-content-between justify-content-lg-start flex-wrap mr-3 mb-3"
		>
			<div className="mt-1">
				<Button 
					onClick={refresh}
					variant="outline-success"
					size="sm"
					block
				>
					Refresh <i className="fa fa-sync-alt"/>
				</Button>
				<strong className="d-flex justify-content-between">
					Filter by Date
				</strong>
				<Form.Check 
					onChange={e=>{
						setFilterByDateRange(e.target.checked)
						if (!e.target.checked) {
							setEndDate(startDate)
						}
					}}
					type="switch"
					id="date-filter-switch"
					label="Filter By Date Range"
				/>
				<div className="d-flex flex-column">
					<DatePicker
						selected={startDate}
						onChange={(selectedDate)=>{
							//clear out the url param
							history.replace('/financials_dashboard')
							setStartDate(selectedDate)
							if(!filterByDateRange){
								setEndDate(selectedDate)
							}
						}}
						customInput={<Form.Control size="sm" placeholder="Date"/>}
						isClearable
					/>
					{filterByDateRange&&
						<DatePicker
							selected={endDate}
							onChange={setEndDate}
							customInput={<Form.Control className="mt-1" size="sm" placeholder="Date"/>}
							isClearable
						/>
					}
				</div>
			</div>
			{user.account_type!=='client'&&
				<div>
					<strong className="d-block mt-2">Filter by Client</strong>
					<Form.Control size="sm" 
						onChange={e=>{ setClientQuery(e.target.value) }}
						value={clientQuery}
						placeholder="Client name"
					/>
				</div>
			}
			<div>
				<strong className="d-block mt-2">Filter by Payment Amount</strong>
				<Form.Control size="sm" 
					onChange={e=>{ setAmountQuery(e.target.value) }}
					value={amountQuery}
					placeholder="Payment amount"
				/>
			</div>
			<div>
				<strong className="d-block mt-2">Filter by Payment ID</strong>
				<Form.Control size="sm" 
					onChange={e=>{ 
						history.replace('/financials_dashboard/')
						setIDQuery(e.target.value) 
					}}
					value={IDQuery}
					placeholder="Payment id"
				/>
			</div>
		</div>
	)

	const [showFilterPopover,setShowFilterPopover] = useState(false)

	return (
		<div 
			className="d-flex flex-column pb-2" 
			style={{height:'100%',overflow:'hidden'}}
		>
			{isOwner&&
				<div className="mb-2">
					<small>
						<a
							href={stripePayoutUrl}
							target="_blank"
							rel="noopener"
						>
							View Payout Dashboard
						</a>
					</small>
				</div>
			}
			{status==='pending'?
				<div className="text-center">
					Loading payments <Spinner animation="border" size="sm"/>
				</div>
				:
				<div style={{height:'100%',overflow:'hidden'}} className="d-flex flex-column flex-lg-row">
					<div className="d-none d-lg-block">
						{filters}
					</div>
					<div className="d-lg-none mb-1">
						<OverlayTrigger 
							placement="right"
							show={showFilterPopover}
							overlay={
								<Popover>
									<Popover.Content>
										{filters}
									</Popover.Content>
								</Popover>
							}
						>
							<Button 
								variant={showFilterPopover?'outline-danger':'outline-primary'}
								onClick={()=>{
									setShowFilterPopover(p=>!p)
								}}
								size="sm"
							>
								<i className={showFilterPopover?'fas fa-times':'fas fa-filter'}/> Filters
							</Button>
						</OverlayTrigger>
					</div>
					<div style={{
						height:'100%',
						overflow:'hidden',
						border:'1px solid #ccc',
						borderRadius:'5px',
						width:'100%',
					}}>
						<div style={{
							padding:'4px 8px',
							display:'flex',
							background:'#00041c',
							color:'#fff',
							flex:'0 0 auto'
						}}>
							<span style={{width:'100px'}}>
								Date
								<Button 
									onClick={()=>{setSortMultiplier(prev=>prev*-1)}} 
									size="sm" 
									variant="link" 
									className="text-white"
								>
									<i style={{fontSize:'16px'}} className={
										sortMultiplier === -1
										?"fa fa-sort-numeric-down"
										:"fa fa-sort-numeric-down-alt"
									}/>
								</Button>
							</span>
							{user.account_type !== 'client'&&
								<div style={{width:'180px'}}>
									<span className="mx-2 text-muted">|</span>
									<span>Client Name</span>
								</div>
							}
							<span className="mx-2 text-muted">|</span>
							<span>Comments</span>
							<span style={{width:'160px'}} className="ml-auto">
								Amount
							</span>
							<span className="mx-2 text-muted">|</span>
							<span style={{width:'74px'}}>
								ID
							</span>
						</div>
						{filteredPayments.length>0&&
							<Total amount={total} ISO={filteredPayments[0].currency_ISO} />
						}
						<div style={{
							height:'100%',
							overflow:'auto',
						}}>
							{
								filteredPayments.map( p => <Payment payment={p}/> )
							}
							<div style={{height:'80px'}}/>
						</div>
					</div>
				</div>
			}
		</div>
	)
}






export default Payments